<template>
	<v-container class="pa-4">
		<v-layout row wrap class="px-2">
			<v-flex xs12 sm12 md12>
				<v-card
					class="mx-auto mb-5"
					flat
					@click="$inertia.visit($route('profile.index'))"
				>
					<v-list subheader two-line>
						<v-list-item>
							<v-list-item-content>
								<v-list-item-title>
									{{ $t("title.welcome") }}
									<span v-if="customer">
										{{ customer.display_name }}</span
									>
								</v-list-item-title>

								<v-list-item-subtitle>
									<span v-if="!customer"
										>Please login/register to
									</span>
									Manage Your Profile, Orders, <br />
									Reservations And More</v-list-item-subtitle
								>
							</v-list-item-content>
							<v-list-item-action>
								<v-avatar size="100">
									<v-img
										:src="
											customer_image
												? customer_image
												: 'https://www.psi.org.kh/wp-content/uploads/2019/01/profile-icon-300x300.png'
										"
										width="100px"
										height="100px"
									></v-img>
								</v-avatar>
							</v-list-item-action>
						</v-list-item>
					</v-list>
				</v-card>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<template v-for="(item, i) in menus">
				<v-flex :key="i" xs4 sm4 md4 class="py-2 px-2">
					<v-hover v-slot="{ hover }">
						<v-card
							outlined
							color="#1f2a40"
							dark
							@click="$inertia.visit(item.route)"
							:class="{ 'on-hover': hover }"
							height="120px"
							class="mt-n2"
						>
							<v-card-title primary-title class="py-1">
								<v-spacer></v-spacer>
								<v-icon size="60px">{{ item.icon }}</v-icon>
								<v-spacer></v-spacer>
							</v-card-title>
							<v-card-actions align="center">
								<v-spacer></v-spacer>
								<span
									:class="[
										$vuetify.breakpoint.mdAndUp
											? 'title'
											: 'text-caption',
									]"
									>{{ item.title }}</span
								>
								<v-spacer></v-spacer>
							</v-card-actions>
						</v-card>
					</v-hover>
				</v-flex>
			</template>
		</v-layout>
	</v-container>
</template>

<script>
	import { Link } from "@inertiajs/inertia-vue";
	export default {
		props: ["customer", "customer_image"],
		components: {
			Link,
		},
		data() {
			return {
				menus: [
					{
						icon: "mdi-calendar",
						title: this.$t("title.make_a_reservation"),
						route: this.$route("reservation.tenants"),
						color: "#1f2a40",
					},
					{
						icon: "mdi-book-open-page-variant",
						title: this.$t("title.check_menus"),
						route: this.$route("discover.map"),
						color: "#141F35",
					},
					{
						icon: "mdi-map",
						title: this.$t("title.find_restaurants"),
						route: this.$route("discover.map"),
						color: "#1f2a40",
					},
					{
						icon: "mdi-pencil-box-multiple",
						title: this.$t("title.rate_us"),
						route: this.$route("discover.map"),
						color: "#141F35",
					},
					{
						icon: "mdi-wallet-giftcard",
						title: this.$t("title.book_an_event"),
						route: this.$route("event.index"),
						color: "#1f2a40",
					},
					{
						icon: "mdi-wallet-membership",
						title: this.$t("title.view_membership"),
						route: this.$route("membership.index"),
						color: "#141F35",
					},
					{
						icon: "mdi-map-search",
						title: this.$t("title.discover_outlets"),
						route: this.$route("discover.map"),
						color: "#1f2a40",
					},
					{
						icon: "mdi-card-search-outline",
						title: this.$t("title.review_order_or_reservation"),
						route: this.$route("shop.orders.index"),
						color: "#141F35",
					},
					{
						icon: "mdi-wallet",
						title: this.$t("title.top_up_credits"),
						color: "accent",
						route: this.$route("wallet.index"),
						color: "#1f2a40",
					},
				],
			};
		},
	};
</script>
<style  scoped>
.v-card:not(.on-hover) {
	opacity: 0.9;
}
</style>